import { IScene } from '@app/@types/scenes/scenes'

export const getNewScenesIdOrder = (sortedScenes: Array<IScene>): Array<number> => sortedScenes.map((scene) => (scene.id))
